$(function () {
    var pagetop = $('#page_top');
    // ボタン非表示
    pagetop.hide();

    // 100px スクロールしたらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});
//メインスライダー
$(function () {
    // centerPaddingを計算する関数
    function getCenterPadding() {
        var windowWidth = $(window).width();
        if (windowWidth <= 768) {
            return '0px';
        } else if (windowWidth <= 1200) {
            return '5vw';
        } else {
            // ブラウザ幅が1200pxを超える場合、余白を計算
            var padding = (windowWidth - 1200) / 2;
            return padding + 'px';
        }
    }

    // スライダー初期化
    $('.main-slider').slick({
        centerMode: true,
        centerPadding: getCenterPadding(),
        slidesToShow: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    fade: true,
                    cssEase: 'linear'
                }
            }
        ]
    });

    // ウィンドウリサイズ時にcenterPaddingを更新（769px以上のみ）
    $(window).on('resize', function () {
        if ($(window).width() > 768) {
            $('.main-slider').slick('slickSetOption', 'centerPadding', getCenterPadding(), true);
        }
    });
});
//ヘッダースクロール制御
$(function () {
    $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var $header = $('#mainHeader.top-page');
        var $headerLogo = $header.find('.header-logo');

        if ($header.length && $headerLogo.length) {
            var currentSrc = $headerLogo.attr('src');

            if (scrollTop > 500) {
                $header.addClass('is-scroll');
                $('#menu-btn.top-page').addClass('is-scroll');
                // header 内の logo-w.svg から logo.svg に変更
                if (currentSrc && currentSrc.includes('logo-w.svg')) {
                    $headerLogo.attr('src', currentSrc.replace('logo-w.svg', 'logo.svg'));
                }
            } else {
                $header.removeClass('is-scroll');
                $('#menu-btn.top-page').removeClass('is-scroll');
                // header 内の logo.svg から logo-w.svg に戻す
                if (currentSrc && currentSrc.includes('logo.svg') && !currentSrc.includes('logo-w.svg')) {
                    $headerLogo.attr('src', currentSrc.replace('logo.svg', 'logo-w.svg'));
                }
            }
        }
    });
});

//ドロワー用
$(document).ready(function () {
    $('.drawer').drawer({
        iscroll: {
            mouseWheel: false
        }
    });
});
jQuery(function () {
    $('.drawer').drawer();
    $('.drawer-nav li a').on('click', function () {
        $('.drawer').drawer('close');
    });
});

//メニューボタン用
$(function () {
    $('#menu-btn').on('click', function (e) {
        e.preventDefault();

        if ($('.drawer-menu').hasClass('active')) {
            // メニューを閉じる
            $('.drawer-menu').removeClass('active');
            $('.menu-overlay').removeClass('active');
            $('#menu-btn').removeClass('active');
            $('.global-nav').removeClass('menu-hidden');
            setTimeout(function () {
                $('.menu-overlay').remove();
            }, 300);
        } else {
            // メニューを開く
            if ($('.menu-overlay').length === 0) {
                $('body').append('<div class="menu-overlay"></div>');
                // オーバーレイクリックで閉じる処理を追加
                setTimeout(function () {
                    $('.menu-overlay').on('click', function () {
                        $('.drawer-menu').removeClass('active');
                        $('.menu-overlay').removeClass('active');
                        $('#menu-btn').removeClass('active');
                        $('.global-nav').removeClass('menu-hidden');
                        setTimeout(function () {
                            $('.menu-overlay').remove();
                        }, 300);
                    });
                }, 50);
            }
            // activeクラスを追加
            setTimeout(function () {
                $('.drawer-menu').addClass('active');
                $('.menu-overlay').addClass('active');
                $('#menu-btn').addClass('active');
                $('.global-nav').addClass('menu-hidden');
            }, 10);
        }
    });

    // .ml-favoriteクリック時にもメニューを閉じる
    $('.ml-favorite').on('click', function () {
        if ($('.drawer-menu').hasClass('active')) {
            $('.drawer-menu').removeClass('active');
            $('.menu-overlay').removeClass('active');
            $('#menu-btn').removeClass('active');
            $('.global-nav').removeClass('menu-hidden');
            setTimeout(function () {
                $('.menu-overlay').remove();
            }, 300);
        }
    });
});

//シリーズスライダー
$(function () {
    $('.series-slider').each(function () {
        $(this).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        arrows: false
                    }
                }
            ]
        });
    });
});

//シリーズページ画像スライダー
$(function () {
    $('.product-img-slider').each(function () {
        $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '105px',
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '60px',
                        arrows: false
                    }
                }
            ]
        });
    });
});

//タブ用
$(function () {
    $('.tabName li').click(function () {
        var index = $('.tabName li').index(this);
        $('.tabName li').removeClass('active');
        $(this).addClass('active');
        $('.tabArea >li').removeClass('show').eq(index).addClass('show');
    });
});

//ランキングスライダー
$(function () {
    $('.ranking-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 800,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.7,
                    infinite: false
                }
            }
        ]
    });
});

//recommend-slider
$(function () {
    $('.recommend-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.7,
                    infinite: false
                }
            }
        ]
    });
});

//ランキングタブ用
$(function () {
    $('.tab-ranking li').click(function () {
        var index = $('.tab-ranking li').index(this);
        $('.tab-ranking li').removeClass('active');
        $(this).addClass('active');
        $('.tab-contents .ranking-slider').removeClass('show').eq(index).addClass('show');

        // スライダーの再描画
        setTimeout(function () {
            $('.tab-contents .ranking-slider.show').slick('setPosition');
        }, 10);
    });
});

//コミットメントスライダー
$(function () {
    $('.commit-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800
    });
});
//お客様の声スライダー
$(function () {
    $('.voice-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        rtl: true,
        infinite: true,
        variableWidth: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.6,
                    rtl: false,
                    variableWidth: false,
                    infinite: false,
                    dots: false
                }
            }
        ]
    });
});
//サブメニュー用
$(function () {
    $('.has-sub-menu > a').on('click', function (e) {
        e.preventDefault();
        var $parent = $(this).parent();
        var $submenu = $parent.find('.sub-menu');

        // 他の開いているサブメニューを閉じる
        $('.has-sub-menu').not($parent).removeClass('open').find('.sub-menu').slideUp();

        // クリックしたサブメニューをトグル
        $parent.toggleClass('open');
        $submenu.slideToggle();
    });
});

//FAQアコーディオン
$(function () {
    $('.faq-area details').each(function () {
        var $details = $(this);
        var $summary = $details.find('summary');
        var $content = $details.find('.faq-content');

        // 初期状態で非表示
        if (!$details.attr('open')) {
            $content.hide();
        }

        $summary.on('click', function (e) {
            e.preventDefault();

            if ($details.attr('open')) {
                // 閉じる
                $content.slideUp(300, function () {
                    $details.removeAttr('open');
                });
            } else {
                // 開く
                $details.attr('open', 'open');
                $content.slideDown(300);
            }
        });
    });
});

//////////////////////////////////////////////////
//iOSサファリ用 下部のメニュー被り解決
//※ブラウザ幅でのリアルタイム処理より先に記述する
//////////////////////////////////////////////////
jQuery(function () {
    $('.drawer').drawer();
    $('.drawer-nav li a').on('click', function () {
        $('.drawer').drawer('close');
    });
});
const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);
// 初期化
setFillHeight();

//商品画像スライダー
$(function () {
    // メイン画像のみSlick適用
    $('.product-img .product-main-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: false,
        infinite: false
    });

    // Native scrolling keeps thumbnails at the position where the gesture ends.
    // Delegate taps so variant image replacement does not require rebinding.
    document.querySelectorAll('.product-img .thumbnail-list').forEach(function (list) {
        list.addEventListener('click', function (event) {
            var item = event.target.closest('.thumb-items');
            if (!item || item.parentElement !== list) return;
            var items = Array.from(list.children);
            var main = list.closest('.product-img').querySelector('.product-main-img');
            if (!main || !main.classList.contains('slick-initialized')) return;
            $(main).slick('slickGoTo', items.indexOf(item));
            items.forEach(function (thumb) {
                thumb.classList.toggle('active', thumb === item);
            });
        });
        if (list.firstElementChild) list.firstElementChild.classList.add('active');
    });
});

//商品詳細アコーディオン
$(function () {
    // console.log('商品詳細アコーディオン初期化');
    // console.log('.detail-blockの数:', $('.detail-block').length);

    // 初期状態で.detail-contentsを非表示
    $('.detail-block .detail-contents').hide();

    // series-blockとdesign-blockはデフォルトで開いた状態にする
    $('.detail-block.series-block, .detail-block.design-block').each(function () {
        $(this).addClass('is-open');
        $(this).find('.detail-contents').show();
    });

    $('.detail-block .detail-ttl').on('click', function () {
        // console.log('.detail-ttlがクリックされました');

        var $contents = $(this).next('.detail-contents');
        var $block = $(this).closest('.detail-block');

        // console.log('$contentsの数:', $contents.length);
        // console.log('$blockの数:', $block.length);

        // トグル
        $contents.slideToggle(300);
        $block.toggleClass('is-open');

        // console.log('is-openクラス:', $block.hasClass('is-open'));
    });
});

// コレクションサイドバーアコーディオン（SP時のみ）
$(function () {
    // console.log('コレクションサイドバーアコーディオン初期化');

    function initCollectionSideAccordion() {
        var windowWidth = $(window).width();

        if (windowWidth <= 768) {
            // SP: アコーディオンを有効化
            $('.collection-side .side-wrapper').hide();
            $('.collection-side').removeClass('is-open');
        } else {
            // PC: アコーディオンを無効化（常に表示）
            $('.collection-side .side-wrapper').show();
            $('.collection-side').removeClass('is-open');
        }
    }

    // 初期化
    initCollectionSideAccordion();

    var prevWinWidth = $(window).width();

    // リサイズ時に再初期化
    $(window).on('resize', function () {
        var currentWinWidth = $(window).width();
        if (currentWinWidth !== prevWinWidth) {
            initCollectionSideAccordion();
            prevWinWidth = currentWinWidth;
        }
    });

    // クリックイベント
    $('.collection-side .side-ttl').on('click', function () {
        var windowWidth = $(window).width();

        // SP時のみ動作
        if (windowWidth <= 768) {
            // console.log('.side-ttlがクリックされました');

            var $wrapper = $(this).next('.side-wrapper');
            var $side = $(this).closest('.collection-side');

            // トグル
            $wrapper.slideToggle(300);
            $side.toggleClass('is-open');
            $(this).toggleClass('is-open');
            $wrapper.toggleClass('is-open');
        }
    });
});

// スクロールフェードイン
// ─────────────────────────────────────────────────
// 【対象セレクターの管理】
//   FADE      : スライド＋フェードインする要素
//   FADE_ONLY : フェードインのみの要素
// クラス名が変わったらここだけ修正すればOK。
// アニメーションのロジックは data-fade 属性で動くため
// クラス名に依存しない。
// ─────────────────────────────────────────────────
(function () {
    // スライド＋フェード 対象
    var FADE = [
        '#MainContent *',
        '#mainFooter *',
    ];

    // フェードのみ 対象（タイトルなど目立つ要素）
    var FADE_ONLY = [
        '.test',
    ];

    // アニメーションを除外する対象（クラス名、IDなど）
    // ※指定した要素自体と、その中にあるすべての子要素が除外されます
    var EXCLUDE = [
        '.no-fade',             // 例: クラスでの除外
        '#ignore-section',      // 例: IDでの除外
        '.drawer-menu',         // メニュー等、最初から非表示のものは除外推奨
        '.mv-section',
        '.voice-slider',
        '.h-area',
        '.series-slider',
        '.top_touch .inner-l',
        '.ranking-slider',
        '.voice-slider',
        '.top_touch .txt-area',
        '.slick-list draggable',
        '.slick-track',
        '.slick-slide',
        'br',
        '.slick-slider *'       // スライダーの中身がチラつく場合は除外推奨
    ];

    // 指定した要素自体のみを除外する対象（子要素は除外されません）
    var EXCLUDE_SELF_ONLY = [
        '.page-kodawari-contents .inner',
        '.page-kodawari-contents',     // 例: この要素自身はアニメーションしないが、子要素はする
    ];

    // ── ① JS で data-fade 属性を付与（HTMLは変更しない）
    document.addEventListener('DOMContentLoaded', function () {
        var excludeSelector = EXCLUDE.length > 0 ? EXCLUDE.join(',') : null;
        var excludeSelfSelector = EXCLUDE_SELF_ONLY.length > 0 ? EXCLUDE_SELF_ONLY.join(',') : null;

        function isExcluded(el) {
            // 指定した要素、またはその中の子孫要素であれば true（除外）
            if (excludeSelector && el.closest(excludeSelector) !== null) {
                return true;
            }
            // 指定した要素自身であれば true（除外）
            if (excludeSelfSelector && el.matches(excludeSelfSelector)) {
                return true;
            }
            return false;
        }

        FADE.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
                if (!isExcluded(el)) {
                    if (!el.hasAttribute('data-fade')) {
                        el.setAttribute('data-fade', 'slide');
                    }
                }
            });
        });

        FADE_ONLY.forEach(function (sel) {
            document.querySelectorAll(sel).forEach(function (el) {
                if (!isExcluded(el)) {
                    // 全要素指定(*)で「slide」が付与されていても、「only」で強制上書きする
                    el.setAttribute('data-fade', 'only');
                }
            });
        });

        // ── ② アニメーションロジック（data-fade 属性のみを参照）
        var targets = document.querySelectorAll('[data-fade]');
        if (!targets.length) return;

        // CSS を <head> へ動的挿入
        var style = document.createElement('style');
        style.textContent =
            '[data-fade]{opacity:0;transition:opacity .7s ease,transform .7s ease;}' +
            '[data-fade="slide"]{transform:translateY(8px);}' +
            '[data-fade].is-visible{opacity:1;transform:none;}';
        document.head.appendChild(style);

        function isInView(el) {
            var r = el.getBoundingClientRect();
            return r.top < window.innerHeight && r.bottom > 0;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    requestAnimationFrame(function () {
                        entry.target.classList.add('is-visible');
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.08 });

        targets.forEach(function (el) {
            observer.observe(el);
        });

        // 読み込み時に既に画面内の要素は即時フェードイン
        requestAnimationFrame(function () {
            targets.forEach(function (el) {
                if (isInView(el)) el.classList.add('is-visible');
            });
        });
    });
})();

// 価格帯スライダー
$(function () {
    var $slider = $('#priceRangeSlider');
    var $priceMax = $('.price-max');
    var $decisionBtn = $('.price-decision-btn');

    if ($slider.length) {
        // スライダーの値が変更されたときの処理
        $slider.on('input', function () {
            var value = parseInt($(this).val());
            var formattedValue = '¥' + value.toLocaleString();
            $priceMax.text(formattedValue);
        });

        // 決定ボタンがクリックされたときの処理
        $decisionBtn.on('click', function () {
            var maxPrice = parseInt($slider.val());
            console.log('選択された価格帯: ¥0 ~ ¥' + maxPrice.toLocaleString());
            // ここにフィルタリング処理を追加
            // 例: 商品一覧をフィルタリングする
        });
    }
});

// フッターリンクアコーディオン（SP時のみ）
$(function () {
    function initFooterAccordion() {
        if ($(window).width() <= 768) {
            $('.footer-link dd').hide();
            $('.footer-link dt').removeClass('is-open');
        } else {
            $('.footer-link dd').show();
            $('.footer-link dt').removeClass('is-open');
        }
    }

    // 初期化
    initFooterAccordion();

    // リサイズ時に再初期化
    var prevWinWidth = $(window).width();
    $(window).on('resize', function () {
        var currentWinWidth = $(window).width();
        if (currentWinWidth !== prevWinWidth) {
            initFooterAccordion();
            prevWinWidth = currentWinWidth;
        }
    });

    // クリックイベント
    $('.footer-link dt').on('click', function (e) {
        if ($(window).width() <= 768) {
            e.preventDefault();
            var $wrapper = $(this).siblings('dd');
            var $dt = $(this);

            $wrapper.slideToggle(300);
            $dt.toggleClass('is-open');
        }
    });
});


